// removed by extract-text-webpack-plugin
module.exports = {"panel":"BasePanel__panel"};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/panels/BasePanel/BasePanel.css
// module id = 1393
// module chunks = 8